'use strict';

var PopoverService = function PopoverService() {
  function getTopForLeftRightPosition(data, height) {
    return data.offset.top + data.height / 2 - height / 2;
  }
  function getLeftFromTopBottomPosition(data, width) {
    return data.offset.left + data.width / 2 - width / 2;
  }
  function calculatePosition(data, position, width, height) {
    var newPosition = {};
    var margin = 1;
    switch (position) {
      case 'left':
        newPosition.left = data.offset.left - width - margin;
        newPosition.top = getTopForLeftRightPosition(data, height);
        break;
      case 'top':
        newPosition.left = getLeftFromTopBottomPosition(data, width);
        newPosition.top = data.offset.top - height - margin;
        break;
      case 'bottom':
        newPosition.left = getLeftFromTopBottomPosition(data, width);
        newPosition.top = data.offset.top + data.height + margin;
        break;
      case 'top-right':
        newPosition.left = data.offset.left + data.width;
        newPosition.top = data.offset.top - height - margin;
        break;
      case 'top-left':
        newPosition.left = data.offset.left - width - margin;
        newPosition.top = data.offset.top - height - margin;
        break;
      default:
        newPosition.left = data.offset.left + data.width + margin;
        newPosition.top = getTopForLeftRightPosition(data, height);
        break;
    }
    return newPosition;
  }
  function getUpdatedPlacementData(targetPosition, popoverHeight, popoverWidth, popoverPlacement) {
    var newPlacementData = {};
    switch (popoverPlacement) {
      case 'top':
        var popoverHeightExceedsScreen = popoverHeight > targetPosition.offset.top;
        newPlacementData.placement = popoverHeightExceedsScreen ? 'bottom' : 'top';
        newPlacementData.position = popoverHeightExceedsScreen ? 'bottom' : 'top';
        break;
      case 'left':
        var popoverWidthExceedsScreen = popoverWidth > targetPosition.offset.left;
        newPlacementData.placement = popoverWidthExceedsScreen ? 'right' : 'left';
        newPlacementData.position = popoverWidthExceedsScreen ? 'right' : 'left';
        break;
      default:
        newPlacementData.placement = popoverPlacement;
        newPlacementData.position = popoverPlacement;
        break;
    }
    return newPlacementData;
  }
  function getPlacementData(scope, data) {
    return data.placement && data.placement !== '' ? data.placement : scope.placement;
  }
  return {
    calculatePosition: calculatePosition,
    getUpdatedPlacementData: getUpdatedPlacementData,
    getPlacementData: getPlacementData
  };
};
PopoverService.$inject = [];
module.exports = PopoverService;